import publicEndpoints from "@/config/publicEndpoints.json";

export default {
  // Endpoints with proxy paths
  loginEndpoint: "/auth/login",
  registerEndpoint: "/auth/signup",
  existingUserCheckEndpoint: "/auth/check_existing",
  refreshEndpoint: "/api/jwt/refresh-token",
  logoutEndpoint: "/api/jwt/logout",
  requestResetPassword: "/auth/password/reset",
  resetPassword: "/auth/password/update_password",
  organizationEndpoint: "/api/organizations",

  duplicates: "/api/duplicates",

  //users
  users: "/api/users",

  company: "/api/company",

  requestIntegration: "/api/request_integration",

  //support
  openTicket: "/api/support/open_ticket",
  buySupportHours: "/api/support/buy_support_hours",

  //notification
  notifications: "/api/notifications",

  // //Dashboard
  billing: "/api/billings",
  // billingDetail: 'billings/detail/',

  //Stats
  dashboardStats: "/api/dashboard/stats",

  // fees
  feesType: "/api/fee_types",

  fees: "/api/fees",

  feesRules: "/api/fee_rules",

  family: "/api/family",

  sendReceipts: "/api/send_receipts",

  receipts: "/api/receipts",
  paidInvoices: "/api/golf_paid_invoices",

  upload: "/api/uploads",

  //contracts
  contracts: "/api/contracts",

  // sub-contract
  subContract: "/api/configurations/sub-contract",
  apiConfig: "/api/configurations/api",

  // schedules
  schedules: "/api/schedules",

  // registers
  registers: "/api/register",

  // //Tier
  tierList: "/api/duplio_tiers",

  // //Configure / Settings
  configure: "/api/configurations",

  // suppliers
  suppliers: "/api/suppliers",

  //Field mapper
  fieldMapper: "/api/field_mapper",

  transaction: "/api/transaction-id-fields",

  //Available Resource
  availableResource: "/api/available-resources",

  // //Subscription Packages
  packages: "/api/packages",
  subscriptions: "/api/subscriptions",

  paymentPlan: "/api/payment_plans",

  moduleSubscription: "/api/subscription",

  smsPlan: "/api/sms_plans",

  allModules: "/api/modules",

  // //Faq
  faqCategories: "/api/faq_categories",
  videoGuides: "/api/video_guides",
  listfaqByCategories: "/api/faq",

  changePassword: "/auth/password/change",

  //guide
  guide: "/api/guides",

  // helptext
  helptext: "/api/helptexts",

  //members
  members: "/api/members",

  // billing
  memberBilling: "/api/member_billing",

  memberCategory: "/api/membercategories",
  memberPlayer: "/api/playercategories",
  memberCare: "/api/member_care",

  //role
  permissions: "/api/permissions",

  //Statistic pages

  //Contracts tabs
  contractsTab: "/api/statistics/contracts",
  gitMembers: "/api/git/list_members",
  gitActions: "/api/git",

  //Get all customer
  customers: "/api/customers",

  // Sync
  sync: "/api/synchronize",

  //Customers Tabs
  customerstab: "/api/statistics/customers",

  // statistics main
  statisticsMain: "/api/statistics",

  // customize
  customization: "/api/customizations",

  //Customers segment
  customersSegments: "/api/segments/customers",

  // Segment main
  segment: "/api/segments",

  //invoice_payment
  invoicePayment: "/api/invoice_payment",

  //articles
  articles: "/api/articles",

  //invoices
  invoices: "/api/invoices",

  // tags
  tagLink: "/api/tags",

  // invoiceAction : ''

  // event-log
  eventLog: "/api/eventlogs",

  //Blogs
  listBlog: "/api/blog",
  blogCategories: "/api/blog-categories",

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: "token",

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",

  // landing
  landingEndpoint: "/api/landing_page",
  hiddenResource: "/api/hidden_resources",
};

export const WITHOUT_AUTH_URL = [
  ...publicEndpoints,
];
